export default {
  blue: '#070D40',
  lightBlue: '#009FE3',
  lightPurple: '#7B6FA4',
  lightTeal: '#CCEFFF',
  mediumBlue: '#16659F',
};
